'use strict';
(function(window) {


    angular.module('itxApp.common').factory('Category', categoryClass);

    categoryClass.$inject = [
        'Product',
        'ItxConfigurationSvc', 
        'ItxCategoryLayoutSvc'
    ];
  
    function categoryClass (
        Product,
        ItxConfigurationSvc, 
        ItxCategoryLayoutSvc
    ){
   
    function Category(category) {
        
        _.extend(this, category);

        this.init();

        return this;
    }

    Category.prototype.init = function() {

        this.config = {};
        this.config.groups = [];
        var _this = this;
        //Initial category configuration
        this.config.showDoubleBox = false; //Default => Hide double boxed
        this.config.showProductGroup = true; //Default => Show Titles
        this.config.hideLabels = false; //Default => Show labels
        

        //Config category
        _.each(this.attachments, function(attachment) {
            if (attachment.path === 'HIDE_BUNDLE_PRODUCTS') {
                _this.config.hideProducts = true;
            }
            if (attachment.name === 'NO_ROLLOVER') {
                _this.config.isNoRollover = true;
            }
            if (attachment.path === 'SHOW_TOTAL_BUNDLE') {
                _this.config.showTotalBundle = true;
            }
            if (attachment.path === 'NO_TITLES') {
                _this.config.showProductGroup = false;
            }
            if (attachment.path === 'SHOW_DOUBLE_BOX') {
                _this.config.showDoubleBox = true;
            }
            if (attachment.path === 'HIDE_LABELS') {
                _this.config.hideLabels = true;
            }
            if (attachment.path === 'SHOW_ALT_IMAGES') {
                _this.config.showAltImages = true;
            }
            if (attachment.path === 'SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK') {
                _this.config.showProductsWithoutStock = true;
            }
            if (attachment.path === 'FILTER_CATEGORY_SIZE') {
                // _this.config.filterSize = attachment.name.split(',');
                _this.config.filterSize = {
                    cmsKey: attachment.path,
                    cmsValue: attachment.name
                };

            }
            if (attachment.path === 'HIDE_FOUR_GRID') {
                _this.config.hideGrid = true;
                ItxCategoryLayoutSvc.setCollapsed();
            }
            if (attachment.path === 'HIDE_TWO_GRID') {
                _this.config.hideGrid = true;
                ItxCategoryLayoutSvc.setExpanded();
            }
            if (attachment.path  === 'FILTER_CATEGORY_PRICE') {
                // this.config.filterPrice = attachment.name;
                _this.config.filterPrice = {
                    cmsKey: attachment.path,
                    cmsValue: attachment.name
                }
                // var filterPath = attachment.name.split(':');
                // if(filterPath && filterPath.length === 2) {
                //     _this.config.filterPrice = {
                //         min: filterPath[0] ? filterPath[0] : 0,
                //         max: filterPath[1] ? filterPath[1] : 25000,
                //         minStep: 0,
                //         maxStep: 10
                //     }
                // }
            }
        });
    };

    //Si es una categoría standard devuelve true
    Category.prototype.isStandard = function() {

        return this.type != 14 && this.type != -1;
    };

    //Si es una categoría standard devuelve true
    Category.prototype.getUrl = function() {
        var url;

       

        if (ItxConfigurationSvc.isSeoUrlsEnabled()) {


            if(this.categoryUrl){
                if(this.categoryUrlParam){
                    return this.categoryUrl + '?celement=' +this.categoryUrlParam;
                }
                else{
                    return this.categoryUrl;
                }
            }
        }


      
        if (this.key && this.key.match(/_CLICK$/)) {
            url = this.shortDescription;
        } else {
            if (this.id) {
                url = Category.getCategoryUrl(this.id, false, false);
            } else {
                url = '/';
            }
        }
        return url;

        



    };


    Category.prototype.fetch = function() {
        var _this = this;
        if (this.fetched) {
           
            return new Promise(resolve => {
                resolve(_this);
            });
        }
        
        return new joyr.catalog.Category({
            categoryId: this.id,
            includeSubcategories: false,
            noStock: this.config.showProductsWithoutStock
        }).done(function(categoryData) {

            _.extend(_this, categoryData.category);
            _this.fetched = true;
            //_this.products = categoryData.products;
            //_this.visibleProducts = categoryData.visibleProducts;
            _this.stock = categoryData.stock;
            
            // Filtramos bundles que no tengan productos en stock
            categoryData.visibleProducts = categoryData.visibleProducts.filter(function(p){
                return !(p.gridElemType === 'BUNDLE' && p.bundleProductSummaries.length === 0);
            });

            _this.visibleProducts = _.map(categoryData.visibleProducts, function(product) {
                return new Product(product, null, null, _this.id);
            });

            //inditex.iCategoryJSON = inditex.iCategoryJSON2;

            /*if (fromProductPage && (!_this.filtersService.categoryObject)) {
                _this.filtersService.initialize(categoryData).done(function() {
                    var products = _this.filtersService.getFilteredProducts();
                    _this.catentries = _this.filtersService.setCategoryCatentries(products);
                    _this.productService.setCatentries(_this.catentries);
                    // notify about changes:
                    _this.$rootScope.$broadcast('product-swiper:catentries-changed', _this.catentries);
                    _this.$rootScope.$digest();
                });
            }*/
            
            return _this;
        });



    };


    


    
    /**
         * Get category page url LEGACY
         * @throws ReferenceError
         * @param {Number} categoryId - category identifier
         * @param {Boolean} isMobile - if true, returns mobile url
         * @param {Boolean} isAjax - if true, returns ajax url
         * @param {object} extraParams - an object with extra params to add to the URL. If included, this object will be extended
         *  Esta es la función heredada de inditex..
         * @returns {String}
         */
        Category.getCategoryUrlLegacy = function(categoryId, isMobile, isAjax, extraParams) {
            
            if (!categoryId) {
                throw new ReferenceError('Missing parameter: categoryId');
            }
          
           var params;
            if (ItxConfigurationSvc.isSeoUrlsEnabled()) {

                params =  {
                    storeId: inditex.iStoreId,
                    langId: inditex.iLangId,
                    categoryId: categoryId
                };
                if(typeof categoryId === 'string'){
                    categoryId = parseInt(categoryId);
                }
                var category = joyr.catalog.utils.findCategoryById(categoryId, inditex.iCategoryTreeJSON.categories);
                if(category){
                    
                    if(category.viewCategoryId){
                        category = joyr.catalog.utils.findCategoryById(category.viewCategoryId, inditex.iCategoryTreeJSON.categories);
                    }
                    
                    if(category && category.categoryUrl){
                        var baseDomain = joyr.utils.getCommonPageUrl('ItxHomePage', false, false);
                        if(category.categoryUrlParam){
                            return baseDomain + category.categoryUrl + '?celement=' +category.categoryUrlParam;
                        }
                        else{
                            return baseDomain + category.categoryUrl;
                        }
                       
                    }
                }
            } 
            //Default method..
             params = _.extend(extraParams, {
                storeId: inditex.iStoreId,
                langId: inditex.iLangId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId
            });
            return inditex.encodeUrl({
                action: 'ItxCategoryPage',
                params: params,
                isMobile: isMobile ? isMobile : false,
                isAjax: isAjax ? isAjax : false
            });
    };
    Category.getCategoryUrl = function(categoryId, isMobile, isAjax, extraParams) {
        var url = Category.getCategoryUrlLegacy(categoryId, isMobile, isAjax, extraParams);
        // TODO ANGULAR Si encontramos Doble barra en la url tenemos que limpiar porque angular no acepta en el routing
        var b = url.split('://')
        if(b.length === 1){
            return url;
        }
        b[1] = b[1].replace(/\/\//g,'/')
        b.join('://')
        var newUrl = b.join('://');
        return newUrl;
    };

    
    window.Category = Category;
    return Category;
} 
   
   
    
    
})(window);